export type InstallState =
  | 'no_metamask'
  | 'snap_not_installed'
  | 'snap_installed_not_connected'
  | 'connected_not_verified'
  | 'verified_active'
  | 'verified_inactive';

export interface StateInputs {
  hasMetaMask: boolean;
  isSnapInstalled: boolean;
  isWalletConnected: boolean;
  subscriptionStatus: 'unknown' | 'active' | 'inactive';
}

export function resolveInstallState(inputs: StateInputs): InstallState {
  if (!inputs.hasMetaMask) return 'no_metamask';
  if (!inputs.isSnapInstalled) return 'snap_not_installed';
  if (!inputs.isWalletConnected) return 'snap_installed_not_connected';
  if (inputs.subscriptionStatus === 'active') return 'verified_active';
  if (inputs.subscriptionStatus === 'inactive') return 'verified_inactive';
  return 'connected_not_verified';
}
